export default __webpack_public_path__ + "static/media/comic-tooltip.a34c95b0.svg";